import { useState } from 'react'
import { Icon } from '@iconify/react'
import AnalysisResultModal from './AnalysisResultModal'

const UploadArea = () => {
  const [selectedFile, setSelectedFile] = useState(null)
  const [preview, setPreview] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [analysisResults, setAnalysisResults] = useState(null)

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      setSelectedFile(file)
      const reader = new FileReader()
      reader.onloadend = () => {
        setPreview(reader.result)
      }
      reader.readAsDataURL(file)
    }
  }

  const handleAnalyze = async () => {
    if (!selectedFile) {
      alert('먼저 계약서 이미지를 업로드해주세요.')
      return
    }

    // 모달 열기 및 로딩 시작
    setIsModalOpen(true)
    setIsLoading(true)
    setAnalysisResults(null)

    try {
      // 시뮬레이션: 실제 API 호출 대신 2초 대기
      await new Promise(resolve => setTimeout(resolve, 2000))

      // 샘플 분석 결과 데이터 (실제로는 API 응답으로 대체)
      const mockResults = [
        {
          title: '불공정 해지 조항',
          summary: [
            '계약 상대방이 일방적으로 계약을 해지할 수 있는 조항이 포함되어 있습니다.',
            '해지 시 손해배상 범위가 과도하게 넓게 설정되어 있어 주의가 필요합니다.',
            '해지 사유가 모호하게 작성되어 있어 분쟁의 소지가 있습니다.'
          ]
        },
        {
          title: '과도한 손해배상 조항',
          summary: [
            '계약 위반 시 실제 손해액을 초과하는 배상금을 요구하는 조항이 있습니다.',
            '위약금이 과도하게 설정되어 있어 법원에서 감액될 가능성이 높습니다.',
            '손해배상 범위가 명확하지 않아 추후 분쟁이 발생할 수 있습니다.'
          ]
        },
        {
          title: '면책 조항',
          summary: [
            '상대방의 고의 또는 중과실에 의한 손해까지 면책하는 조항이 포함되어 있습니다.',
            '법적으로 무효가 될 수 있는 조항이므로 전문가와 상담이 필요합니다.',
            '계약 상대방의 귀책사유로 인한 손해에 대한 책임을 지지 않는다는 내용입니다.'
          ]
        }
      ]

      setAnalysisResults(mockResults)
    } catch (error) {
      console.error('분석 중 오류 발생:', error)
      alert('분석 중 오류가 발생했습니다. 다시 시도해주세요.')
    } finally {
      setIsLoading(false)
    }
  }

  const handleCloseModal = () => {
    if (!isLoading) {
      setIsModalOpen(false)
      setAnalysisResults(null)
    }
  }

  return (
    <div className="px-4 py-6">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-black mb-2">
          잠깐!<br />
          그 도장 찍기 전에,
        </h2>
        <p className="text-black text-sm">
          3초면 독소조항을 찾아냅니다.
        </p>
      </div>

      <div className="mb-4">
        <label htmlFor="file-upload" className="cursor-pointer">
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center bg-gray-50 min-h-[200px] flex items-center justify-center">
            {preview ? (
              <div className="w-full">
                <img 
                  src={preview} 
                  alt="업로드된 계약서" 
                  className="max-h-48 mx-auto rounded"
                />
              </div>
            ) : (
              <div className="flex flex-col items-center py-4">
                <Icon icon="solar:camera-bold" width={64} height={64} className="text-gray-400 mb-4" />
                <p className="text-black font-medium mb-2">
                  계약서 사진 찍어 올리기
                </p>
                <p className="text-gray-500 text-sm">
                  이미지를 선택하거나<br />
                  카메라로 촬영하세요
                </p>
              </div>
            )}
          </div>
          <input
            id="file-upload"
            type="file"
            accept="image/*"
            capture="environment"
            onChange={handleFileChange}
            className="hidden"
          />
        </label>
      </div>

      <button
        onClick={handleAnalyze}
        className="w-full bg-red-500 hover:bg-red-600 text-white font-semibold py-4 px-6 rounded-lg transition-colors"
      >
        계약 위험 분석하기
      </button>

      <AnalysisResultModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        isLoading={isLoading}
        results={analysisResults}
      />
    </div>
  )
}

export default UploadArea

